import React from 'react';

const Checkbox = ({ label, id, onChange, checked, value, disabled, labelClassName, inputClassName, labelStyle }) => (
    <>
        <input
            name={id}
            type="checkbox"
            id={id}
            className={`is-checkradio ${inputClassName ? inputClassName : ""}`}
            disabled={disabled}
            value={value}
            checked={checked}
            onChange={onChange}
        />
        <label htmlFor={id} style={labelStyle} className={`groupLabel ${labelClassName ? labelClassName : ""}`}>
            {label}
        </label>
    </>
)

export default Checkbox;